import { useContext } from 'react';
import { FeatureFlagContext } from '../Context';

export function useFeatureFlags() {
    return useContext(FeatureFlagContext);
}
